exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attention-1 {\n  fill: #FF0000;\n}", ""]);
